import React from "react";

import { useHistory, useParams } from "react-router-dom";

import ConfirmRegister from "../../../../../presentation/pages/register-account/confirm-register";

import { useLucralizeContext } from "../../../../contexts";
import { useAuthContext } from "../../../../contexts/auth";

import { toastUtils } from "../../../../../utils";
import LocalStorageUtils from "../../../../../utils/LocalStorageUtils";
import UserDTO from "../../../../../data/dtos/UserDTO";

type ParamsProps = {
  code: string;
  email: string;
};

const MakeConfirmRegister: React.FC = () => {
  const history = useHistory();
  const params = useParams<ParamsProps>();

  const authContext = useAuthContext();
  const lucralizeContext = useLucralizeContext();

  const confirmSignUp = React.useCallback(async () => {
    if (
      !params.code ||
      !params.code.trim() ||
      !params.email ||
      !params.email.trim()
    ) {
      toastUtils.showMessage({
        message: "Código de cadastro inválido, tente novamente.",
        type: "error",
      });

      history.push("/registrar");
      return;
    }

    let userStorage = LocalStorageUtils.getItem("userRegister");

    userStorage = JSON.stringify({ email: params.email });
    LocalStorageUtils.setItem(userStorage, "userRegister");

    const user = JSON.parse(userStorage) as UserDTO;
    localStorage.setItem("username", user.email);
    await authContext.confirmSignUp({
      code: params.code,
      email: user.email,
    });

    toastUtils.showMessage({
      message: "Conta ativada com sucesso, continue seu cadastro.",
      type: "success",
    });

    lucralizeContext.changeRegisteredUser(user);
    history.push("/cadastro");
  }, [authContext, history, lucralizeContext, params]);

  React.useEffect(() => {
    confirmSignUp();
  }, [confirmSignUp]);

  return <ConfirmRegister />;
};

export default MakeConfirmRegister;
